import React from 'react';
import './FormInput.css';

const FormatInput = ({ value, onChange }) => {
  return (
    <div className="form-input-group">
      <label className="form-label">Format</label>
      <textarea
        value={value}
        onChange={(e) => onChange(e.target.value)}
        className="form-textarea"
        placeholder="e.g., bullet points, structured list"
        rows="4"
      />
    </div>
  );
};

export default FormatInput;

